import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import ContactsInteraction from "./ContactsInteraction";
import useGlobalContext from "../../context/useGlobalContext";
import ClientActionItem from "../Client/ClientActionItem";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";

interface ContactsInteractionViewProps {
  userEmail: string,
  isSlideOverOpen?: boolean;
  removeCustomDateRange?: boolean;
  slideOverParent?: string;
  parentPageIdentifier?: string;
  isClientInteraction?: boolean;
  profileOrgId?: string;
}

type TabKey = "interactions" | "actionItems";

const ContactsInteractionView:React.FC<ContactsInteractionViewProps> = ({userEmail, 
  isSlideOverOpen, slideOverParent, parentPageIdentifier, isClientInteraction, removeCustomDateRange, profileOrgId}) => {
    
    const [tabValue, setTabValue] = useState<TabKey>("interactions");
    const { startEndMeetingTime } = useGlobalContext();
    const handleTabChange = (_event: React.SyntheticEvent, newValue: TabKey) => {
        setTabValue(newValue);
    };

    return (
        <Box className="client-interaction">
          <Box className="client-interaction__tabs-container">
            <Tabs
              value={tabValue}
              onChange={(_e, val) => handleTabChange(_e, val)}
            >
              <Tab label="Interactions" value="interactions" />
              <Tab label="Tasks" value="actionItems" />
            </Tabs>
            <CustomDatePicker {...(!removeCustomDateRange && { customDateRange: "lastThreeMonths" })} isSlideOverOpen={isSlideOverOpen}/>
          </Box>
            <Box className="client-interaction__content">
            {tabValue === "interactions" ? (
              <ContactsInteraction
                userEmail={userEmail}
                startTime={startEndMeetingTime.start_time}
                endTime={startEndMeetingTime.end_time}
                parent_page_identifier={parentPageIdentifier}
                isSlideOverOpen = {isSlideOverOpen}
                slideOverParent={slideOverParent}
                isClientInteraction={isClientInteraction}
                profileOrgId={profileOrgId}
              />
            ) : (
              <ClientActionItem
                userEmail={userEmail}
                parent_page_identifier={parentPageIdentifier}
                profileOrgId={profileOrgId}
              />
            )}
          </Box>
        </Box>
      );
    
}

export default ContactsInteractionView;